import { MapState } from './map/state/map-state';
import { WidgetState } from './widget/state/widget_state';
import { combineReducers } from '@ngrx/store';
import { mapReducer } from './map/state/map-reducer';
import { widgetReducer } from './widget/state/widget_reducer';
import { navigationReducer } from './shared/navigation/state/navigation_reducer';
import { NavigationState } from './shared/navigation/state/navigation_state';
import { IntegrateState } from './integrate/state/integrate_state';
import { integrateReducer } from './integrate/state/integrate_reducer';
import { ManualSetupState } from './integrate/main/manual_setup/store/manual_setup_state';
import { manualSetupReducer } from './integrate/main/manual_setup/store/manual_setup_reducer';
import { mobileReducer } from './mobile/state/mobile-reducer';
import { MobileState } from './mobile/state/mobile-state';

export interface InstallState {
  map: MapState;
  widget: WidgetState;
  navigation: NavigationState;
  integrate: IntegrateState;
  manualSetup: ManualSetupState;
  mobile: MobileState;
}

export const installReducer = combineReducers({
  map: mapReducer,
  widget: widgetReducer,
  navigation: navigationReducer,
  integrate: integrateReducer,
  manualSetup: manualSetupReducer,
  mobile: mobileReducer
});
